import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=3bd4a76c&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=3bd4a76c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd4a76c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bd4a76c')) {
      api.createRecord('3bd4a76c', component.options)
    } else {
      api.reload('3bd4a76c', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=3bd4a76c&scoped=true&", function () {
      api.rerender('3bd4a76c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ZEvfgtQtQ2nZ/JS/teamMember.vue"
export default component.exports